import { createCarousel } from "@/ui/carousel/carousel";
import { createScrollFade } from "@/ui/scroll-fade/scroll-fade";
import { createContentSection } from "../content-section/content-section";
import { createContentStats } from "../content-stats/content-stats";
import { createRankService } from "../rank-service/rank-service";
import { createRankStars } from "../rank-stars/rank-stars";
import "./section-user-reviews.css";

export const createSectionUserReviews = () => {
  const container = document.querySelector<HTMLElement>(
    ".carousel.user-reviews",
  );

  if (container !== null) {
    createCarousel(container);
  }

  createContentSection();
  createContentStats();
  createRankStars();
  createRankService();
  createScrollFade();
};
